module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pulmonology3@2x.6efed58e.png";